export default "__VITE_ASSET__DRFucwYv__"